module.exports = __webpack_public_path__ + "img/asphalted_asphalted.3bb2d131.png";